import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

// interface Option {
//   label: string;
//   value: string;
// }

@Component({
  selector: "host-radio-button",
  templateUrl: "./radio-button.component.html",
  styleUrls: ["./radio-button.component.scss"],
})
export class RadioButtonComponent implements OnInit {
  @Input() options: Array<Option> = [];
  @Input() size: "normal" | "small" | "large" = "normal";
  @Input() value;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
